export const CLIENT_ID = {
  PRODUCTION:
    "596255326039-qvlu04ug995o1p5sqns0fmimo14ais8p.apps.googleusercontent.com",
  STAGING:
    "596255326039-qvlu04ug995o1p5sqns0fmimo14ais8p.apps.googleusercontent.com",
};
